export default __webpack_public_path__ + "static/media/icon_trigger.abfde3ea.svg";